import React, {
  ReactNode,
  ReactElement,
  MouseEvent,
  TextareaHTMLAttributes,
} from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface Props
  extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'title'> {
  /** 左侧内容 */
  title?: ReactNode;
  /** 左侧辅助说明内容 */
  subtitle?: ReactNode;
  /** 右侧内容 */
  extra?: ReactNode;
  /** 样式名称 */
  className?: string;
  /** 样式名称 */
  extraClassname?: string;
  /** 是否显示左侧内容后的冒号 */
  colon?: boolean;
  /** 点击 item 后的回调函数 */
  onClick?: (e: MouseEvent<any>) => void;
}

function TextareaItem(props: Props): ReactElement {
  const {
    title,
    children,
    className,
    onClick,
    colon = true,
    extra,
    extraClassname,
    subtitle,
    ...rest
  } = props;

  const itemCls = classNames(styles.listItemClass, className, {
    [styles.listItemLineClass]: !children,
  });

  const titleCls = classNames(styles.listItemTitleClass, {
    [styles.listItemTitleWithColon]: colon,
  });

  const renderTitle = (): ReactNode => {
    if (!title) {
      return null;
    }

    return (
      <div className={styles.listItemTitleWrapper}>
        <div className={titleCls}>{title}</div>
        {subtitle && <div className={styles.listItemSubtitle}>{subtitle}</div>}
      </div>
    );
  };

  const handleClick = (e: MouseEvent<any>): void => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <div className={itemCls} onClick={handleClick}>
      {renderTitle()}
      <div className={styles.listItemExtraClass}>
        <textarea className={styles.input} {...rest} />
        <span style={{ flex: '0 0 auto' }} className={extraClassname}>
          {extra}
        </span>
      </div>
    </div>
  );
}

export default TextareaItem;
